import { Box, Button, Grid } from '@material-ui/core';
import SaveIcon from '@material-ui/icons/SaveSharp';
import { AdviserDetail } from '../../api/apiClients';
import { useAppDispatch, useAppSelector } from '../../store';
import { Colors, DialogBox, FormLabel, SectionTitleText } from '../controls/helpers';
import { Autocomplete, Select } from '../controls/inputs';
import FormikWrapper from '../containers/FormikWrapper';
import { Client } from '../../common/types';
import { upsertClientAsync } from '../../store/adviser';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import * as yup from 'yup';
 
const getAdviserOptions = (advisers?: AdviserDetail[]) => {
    const options: Array<{ label: string, value: string }> = [];
 
    if (!advisers) return [];
    advisers.map(adviser => options.push({ label: adviser.adviserName!, value: adviser.adviserNumber! }));

    return options;
};

const ConfirmSave = ({ cancel, ok, open, client }: { cancel: () => void; ok?: () => void; open: boolean; client: Client }) => {
    const { isSubmitting, advisers, adviserDetails } = useAppSelector(state => state.adviser);
    const dispatch = useAppDispatch();

    return <DialogBox
        open={open}
        isSubmitting={isSubmitting}
        icon={<SaveIcon htmlColor={Colors.Green} />}> 
        <FormikWrapper
            initialValues={{ ...client, adviserNumber: !client?.adviserNumber ? advisers?.find(p => p.adviserName === adviserDetails?.adviserName)?.adviserNumber : client?.adviserNumber }} 
            validationSchema={yup.object({
                adviserNumber: yup.string().required('Please select an adviser'), 
            })}
            onSubmit={async (values) => {
               await dispatch(upsertClientAsync(values));
               ok && ok();
            }}>
            {() => <>
                <Box pb={3}>
                    <Grid container spacing={3} alignItems="center">
                        <Grid item xs={12}>
                            <SectionTitleText hideBorderBottom hideMarginBottom hideMarginTop>Before you save the application, select the adviser for this client.</SectionTitleText>
                        </Grid>
                        <Grid item sm={4} xs={12}>
                            <FormLabel label="Adviser" />
                        </Grid>
                        <Grid item sm={8} xs={12}>
                            <Autocomplete name="adviserNumber" options={getAdviserOptions(advisers)} endAdornment={<ExpandMoreIcon />} />
                        </Grid>
                    </Grid>
                </Box> 
                <Grid container justifyContent="space-between">
                    <Button variant="contained" type="button" onClick={cancel} disabled={isSubmitting}>Cancel</Button>
                    <Button variant="contained" type="submit" color="primary" disabled={isSubmitting}>Save</Button>
                </Grid>
            </>}
        </FormikWrapper> 
    </DialogBox>
}

export default ConfirmSave;
